import Dashboard from "layouts/Dashboard/Dashboard";
import ForgotPassword from "views/ForgotPassword/ForgotPassword";
import ResetPassword from "views/ResetPassword/ResetPassword";
import ForceChangePassword from "views/ForceChangePassword/ForceChangePassword";
import Login from "views/Login/Login";
import Logout from "views/Login/Logout";

// please make sure to keep all public (non-protected) routes above the protected routes

// TODO: make two nested objects for indexRoutes namely protectedRoutes and publicRoutes
// and render the publicRoutes first in index.js to ensure right order
var indexRoutes = [
  { path: "/login", name: "Login", component: Login },
  { path: "/forgot-password", name: "ForgotPassword", component: ForgotPassword },
  { path: "/reset-password", name: "ResetPassword", component: ResetPassword },
  { path: "/force-change-password", name: "ForceChangePassword", component: ForceChangePassword },
  { path: "/logout", name: "Logout", component: Logout },
  { path: "/*", name: "Home", component: Dashboard, isProtected: true },
];

export default indexRoutes;
